const da = {
  common: {
    language: 'Sprog',
    english: 'English',
    danish: 'Dansk',
    close: 'Luk',
    more: 'Mere',
    profile: 'Profil',
    myPlan: 'Mit abonnement',
    signOut: 'Log ud',
    notifications: 'Notifikationer',
    notAvailable: 'Ikke tilgængelig',
  },
  coach: {
    nav: {
      aria: 'Trænerområde',
      mobileAria: 'Mobil navigation for træner',
      moreAria: 'Mere navigation for træner',
      closeAria: 'Luk trænernavigation',
      hub: 'Trænerhub',
      hubShort: 'Hub',
      live: 'Livesession',
      liveShort: 'Live',
      capture: 'Gruppetest',
      captureShort: 'Test',
      manual: 'Manuel tæller',
      manualShort: 'Tæl',
      verification: 'Gennemgå resultater',
      athletes: 'Atleter',
      teamProgress: 'Holdudvikling',
      programs: 'Programmer',
      identityStudio: 'Trænerprofil',
      myProfile: 'Min profil',
      coachOs: 'Trænerhub',
      moreWorkspace: 'Mere',
      kicker: 'ARGUS // TRÆNER',
      motto: 'Bedre spillere. Bedre mennesker.',
    },
    header: {
      kicker: 'Trænerhub // ARGUS',
      fallbackTitle: 'Trænerområde',
      fallbackTeam: 'Atletudvikling',
      preview: 'Previewtilstand',
      profileAria: 'Åbn trænerprofil',
    },
    sections: {
      kicker: 'ARGUS // TRÆNER',
      backAria: 'Tilbage til trænerhub',
      capture: {
        title: 'Gruppetest',
        description: 'Vælg de atleter, du arbejder med, og start en separat test for hver spiller.',
      },
      review: {
        title: 'Gennemgå resultater',
        description: 'Gennemgå afsluttede tests, der er klar til din bekræftelse.',
      },
      athletes: {
        title: 'Atleter',
        description: 'Se de spillere, der er forbundet med dit trænerområde.',
      },
      live: {
        title: 'Live gruppesession',
        description: 'Følg hver atlet, mens en gruppetest eller træningssession er i gang.',
      },
      progress: {
        title: 'Holdudvikling',
        description: 'Se deltagelse, gennemførelse og udviklingstendenser for holdet.',
      },
      programs: {
        title: 'Træningsprogrammer',
        description: 'Se programmer og opgaver til dine atleter.',
      },
    },
    home: {
      kicker: 'ARGUS // TRÆNERHUB',
      heroLead: 'COACH DET NÆSTE REP.',
      heroAccent: 'SE HELE ATLETEN.',
      heroCopy:
        'Styr arbejdet fra ét sted. Se hvem der har brug for opmærksomhed, start en gruppesession, tildel træning og gennemgå resultater uden at miste atleten bag tallene.',
      today: 'I dag',
      todayNote: 'Dine vigtigste træneropgaver',
      athletes: 'Atleter',
      athletesNote: 'Trup og spillerkontekst',
      liveCapture: 'Livesession',
      liveCaptureNote: 'Følg en gruppetest eller træningssession',
      manualCounter: 'Manuel tæller',
      manualCounterNote: 'Tæl gentagelser, scoringer og missere for valgte atleter',
      assignWork: 'Tildel træning',
      assignWorkNote: 'Programmer og opgaver',
      verification: 'Gennemgå resultater',
      verificationNote: 'Bekræft afsluttede tests',
      activeAthletes: 'Aktive atleter',
      totalAthletes: 'Atleter i alt',
      programs: 'Programmer',
      completion: 'Holdets gennemførelse',
      currentPriority: 'Aktuel prioritet',
      priorityReady: 'Dit trænerområde er klar.',
      priorityEmpty:
        'Byg truppen, tildel træning og begynd at registrere sessioner. ARGUS viser tydeligere prioriteter, efterhånden som aktiviteten vokser.',
      priorityActive:
        'Forbundne atleter: {{count}}. Hold udviklingen i gang med den næste nyttige handling.',
      priorityActiveOne:
        '1 atlet er forbundet. Hold udviklingen i gang med den næste nyttige handling.',
      priorityActiveMany:
        '{{count}} atleter er forbundet. Hold udviklingen i gang med den næste nyttige handling.',
      openAthletes: 'Åbn atleter',
      startCapture: 'Start gruppetest',
      openLive: 'Åbn livesession',
      openPrograms: 'Åbn programmer',
      reviewEvidence: 'Gennemgå resultater',
      signalKicker: 'Holdaktivitet',
      signalTitle: 'VID HVEM DER HAR BRUG FOR DIG NÆST.',
      signalCopy:
        'Holdaktivitet hjælper dig med at se deltagelse og gennemførelse. Åbn den enkelte atlet, når du har brug for historien bag tallet.',
      noCompletion: 'Ikke nok afsluttet arbejde endnu',
      completionReady: '{{value}}% gennemført på holdet',
      evidenceBoundary:
        'Gennemførelse og verifikation fortæller, hvad der er registreret og gennemgået. De bedømmer ikke automatisk atletens præstation.',
    },
  },
}

export default da
